import App from "./App.svelte";

const app = new App({
  target: document.getElementById("g-vis-container"),
  props: { dataUrl: "https://vpap-production.s3.amazonaws.com/media/visuals/custom/static/2021/01/employment-changes/data.json" },
  intro: true
});

export default app;
